var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0269 9.99959L8.43018 7.40283L9.90331 5.92969L13.9732 9.99959L9.90331 14.0695L8.43018 12.5964L11.0269 9.99959Z",
    fill: "#2D293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSmall);
export default __webpack_public_path__ + "static/media/chevron-right-small.607bac3fe344a1da436e1eff8f89baa0.svg";
export { ForwardRef as ReactComponent };